<div class="row">
  <div class="col">
    <a mat-icon-button [routerLink]="['scrolls']" class="mr-1" color="primary">
      <mat-icon>keyboard_backspace</mat-icon>
    </a>
    <span>Hashtag #magic</span>
  </div>
</div>
